module.exports = __webpack_public_path__ + "9f6d22b243645dbd2672ae69c61b2a41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thesafezone/office-ext.jpg
// module id = 337
// module chunks = 1